import { Component, contentChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../page/page.component';
import { PageHeaderComponent } from '../page/page-header/page-header.component';

@Component({
  selector: 'soft-workflow-page',
  imports: [CommonModule, PageComponent, PageHeaderComponent],
  templateUrl: './workflow-page.component.html',
  styleUrl: './workflow-page.component.css',
})
export class WorkflowPageComponent {
  header = contentChild(PageHeaderComponent, { descendants: true });
}
